
import { Observable } from 'rxjs';
import { ICreateAccount } from 'src/app/shared/account/create-account.helper';

export abstract class AccountDataFormService {
  public abstract getData(accountId: string): Observable<any>;

  public abstract updateData(
    value: ICreateAccount, accountId: string
  ): Observable<void>;
}
